module.exports = __webpack_public_path__ + "static/saratoga-3a84d99d31dd7187073aa2f978b20cbd.jpg";